export default __webpack_public_path__ + "static/media/circle_light.4e25c522.svg";